import axios from "axios";
import { useContext } from "react";
import { GlobalContext } from "../../context/Context";
import platform from "platform";
import { useLocation } from "react-router";

export const useApiCall = () => {
  const { state, dispatch } = useContext(GlobalContext);

  const location = useLocation();

  const call = async ({ method, url, data = {}, customToken, onUploadProgress }) => {
    try {
      const isFormData = typeof FormData !== "undefined" && data instanceof FormData;      
      const config = {
        method: method,
        maxBodyLength: Infinity,
        url: `${state.baseUrl}api/auth/${url}`,
        headers: {
          ...(isFormData ? {} : { 'Content-Type': 'application/json' }), // skip for FormData
          'Accept': 'application/json',
          'user_agent': platform.ua,
          'ip': state.ipAddress,
          'device_info': platform.os,
          'browser': platform.name,
          'Authorization': `Bearer ${customToken || state.token}`
        },
        data: data,
        onUploadProgress
      };

      const response = await axios.request(config);
      return response.data;
    } catch (error) {
      // console.warn("API Error:", error.response?.data || error.message);
      if (error.response?.status === 401) {
        dispatch({ type: 'USER_LOGOUT' });
        localStorage.clear();
        sessionStorage.setItem("redirectUrl", `${location?.pathname}${location?.search}${location?.hash}`)
      } else {
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Oops...',
        //   text: error.response?.data?.message || 'Something went wrong!',
        //   showConfirmButton: false,
        // });
      }

      throw error;
    }
  };

  return call;
};
